<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">
        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <div class="search">
              <span>From</span>

              <form autocomplete="off">
                <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="date1">
              </form>

            </div>
            <div class="search">

              <span>To</span>
              <form autocomplete="off">
                <input type="date" [ngModelOptions]="{standalone: true}" [(ngModel)]="date2">
              </form>
            </div>
            <div class="search">
              <form autocomplete="off">
                <input type="text" [ngModelOptions]="{standalone: true}" placeholder="search user" [(ngModel)]="search">
              </form>
              <i class="bi bi-search"></i>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-md-5 col-lg-5">
                    <label class="user">User Tracking of <span>{{name}}</span></label>
                  </div>
                    <div class="col-md-7 col-lg-7 right" style="display: flex;padding-left: 0;justify-content: space-between;">
                      <div class="" style="width:49%;display: flex;">
                          <label class="dates">StartDate:</label>
                          <input type="date" [(ngModel)]="date1" class="form-control">
                      </div>
                      <div class="" style="width:49%;display: flex;">
                          <label class="dates">EndDate:</label>
                          <input type="date" [(ngModel)]="date2" class="form-control">
                      </div>
                    </div> -->
          <div class="col-md-2 col-lg-2" style="padding-right: 0;">
            <!-- <div class="status-list">
                        <div class="status">
                          <i class="bi bi-circle-fill"></i>

                          <p>Task 1</p>
                          <p>Complete</p>
                        </div>
                        <div class="status">
                          <span></span>

                          <p>Task 1</p>
                          <p>Complete</p>
                        </div>
                        <div class="status">
                          <span></span>

                          <p>Task 1</p>
                          <p>Complete</p>
                        </div>
                      </div> -->
            <div class="status-list">
              <h3>Time Line</h3>
              <div class="card" *ngIf="events.length != 0">
                <p-timeline [value]="events">

                  <ng-template pTemplate="content" let-event>
                    {{ event.task }}
                    {{ event.status }}
                  </ng-template>
                  <ng-template pTemplate="opposite" let-event>
                    <small class="p-text-secondary">{{ event.date }}</small>
                  </ng-template>
                </p-timeline>
              </div>
            </div>


          </div>
          <div class="col-md-7 col-lg-7">
            <div class="map-container">
              <div class="map-frame">
                <div id="map">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-lg-3" style="padding-left: 0;">
            <div class="options">
              <p (click)="usersChange('true')">On site</p>
              <p (click)="usersChange('false')">Off site</p>
            </div>
            <!-- <input type="text" placeholder="search user" [(ngModel)]="search" class="search-bar form-control"> -->
            <div class="usersList">
              <p *ngFor="let list of usersList | filter:search"
                (click)="getEmployeeLocationTrackingByIdAndBetweenDates(list.userId, $event)">{{list.userName}}
                ({{list.userId}}) - {{list.userMobileNo}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>